import * as React from "react";
export class WrapperGL extends React.Component {
    constructor(props) {
        super(props);
        this.prepareData = ({ data, idValue, xKey, xMapper, yMapper }) => {
            let i = 0;
            const nonNulls = data[idValue].reduce((acc, item) => (item !== null ? acc + 1 : acc), 0);
            const xy = data[idValue].reduce((acc, item, index) => {
                let _y = item;
                let _x = data[xKey][index];
                if (item !== null && _x !== null) {
                    acc[i * 2] = xMapper(_x);
                    acc[i * 2 + 1] = yMapper(_y);
                    i++;
                }
                return acc;
            }, new Float32Array(nonNulls * 2));
            return { xy };
        };
        this.state = this.prepareData(props);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data ||
            prevProps.xKey !== this.props.xKey ||
            prevProps.xMapper !== this.props.xMapper ||
            prevProps.yMapper !== this.props.yMapper ||
            prevProps.idValue !== this.props.idValue) {
            this.setState(this.prepareData(this.props));
        }
    }
    render() {
        const { children, domainX, domainY } = this.props;
        const { xy } = this.state;
        return React.Children.map(children, (child) => child !== null &&
            React.cloneElement(child, {
                xy,
                domainX,
                domainY,
            }));
    }
}
//# sourceMappingURL=index.js.map